import React, {useEffect, useState} from "react";
import {makeStyles} from "@material-ui/core";
import GridBlock from "components/GridBlock";
import PropTypes from "prop-types";
import Tr from "translations/Translations"
import {connect} from "react-redux";
import AgreementsService from "services/AgreementsService";
import Loading from "components/Loading";
import useSearch from "hooks/useSearch";
import {useDidUpdateEffect} from "hooks/useDidUpdateEffect";
import SimpleTable from "components/complex/simpleTable/SimpleTable";
import BasicSearch from "components/BasicSearch";
import Pagination from "components/Pagination";
import Confirm from "components/popup/confirm/Confirm";
import BoldTypography from "components/BoldTypography";
import WorkableIconDeleteButton from "components/button/WorkableIconDeleteButton";
import WorkableIconPreviewButton from "components/button/WorkableIconPreviewButton";
import {AgreementStateLabel} from "../constants/AgreementState";
import {AgreementTypeLabel} from "../constants/AgreementType";

const useStyles = makeStyles(theme => ({
    typeColumn: {
        width: 170
    },
    buttonColumn: theme.components.table.buttonColumn
}));

function AgreementsCreatedPanel(
    {
        demandId,
        editable,
        agreementsList
    }) {

    const classes = useStyles();
    const {searchData, totalCount, setTotalCount, setPaginationConfig, setSearchConfig} = useSearch();
    const [working, setWorking] = useState(false);
    const [confirmDelete, setConfirmDelete] = useState(null);

    useEffect(() => {
        return () => {
            AgreementsService.clearResources(AgreementsService.AGREEMENTS_RESOURCE_ID);
        }
    }, [demandId]);

    useEffect(() => {
        setWorking(true);
        const {pagination, search} = searchData;
        AgreementsService.getAgreementsList(demandId, pagination, search).then(() => (setWorking(false)));
        // eslint-disable-next-line
    }, [searchData, demandId]);

    useDidUpdateEffect(() => {
        if (agreementsList?.totalCount !== undefined) {
            setTotalCount(agreementsList.totalCount)
        }
    }, [agreementsList?.totalCount]);

    const deleteAgreement = () => {
        AgreementsService.deleteAgreement(demandId, confirmDelete.identity > 0 ? confirmDelete.identity : confirmDelete.extObjId, confirmDelete.identity > 0 ? 'agreement' : 'extObj').then((resp) => {
            if (resp.success) {
                if (agreementsList.items.length === 1) {
                    setPaginationConfig({...searchData.pagination, page: 1})
                } else {
                    setPaginationConfig({...searchData.pagination})
                }
            }
        }).finally(() => setConfirmDelete(null))
    }

    if (!agreementsList) return <Loading/>;

    return (<>
            <GridBlock justify='space-between'>
                <BasicSearch
                    label={Tr('search_part')}
                    searchInProgress={working}
                    doSearch={setSearchConfig}
                />
            </GridBlock>

            <SimpleTable
                headers={
                    [
                        Tr('agreement_subject'),
                        Tr('demand_number'),
                        Tr('type'),
                        Tr('status'),
                        '',
                        ''
                    ]
                }
                items={
                    agreementsList.items.map((x, i) => {
                        return [
                            x.subject,
                            x.number,
                            AgreementTypeLabel(x.type),
                            AgreementStateLabel(x.state),
                            x.actions.preview ? <WorkableIconPreviewButton tooltip={Tr('details')} onClick={() => window.location.href = x.actions.preview.url}/> : null,
                            <WorkableIconDeleteButton onClick={() => setConfirmDelete(x)} disabled={!x.actions.delete}/>
                        ]
                    })
                }
                columnClasses={
                    [
                        undefined,
                        classes.typeColumn,
                        classes.typeColumn,
                        classes.typeColumn,
                        classes.buttonColumn,
                        classes.buttonColumn,
                    ]
                }
            />
            {
                !agreementsList.items.length && <BoldTypography align='center' variant="h6">{Tr('no_options')}</BoldTypography>
            }

            <Pagination config={searchData.pagination} setConfig={setPaginationConfig} totalCount={totalCount} disabled={working}/>

            {
                !!confirmDelete && <Confirm
                    confirmText={confirmDelete.subject}
                    confirmText2={Tr("agreement_delete_confirm")}
                    open
                    onCancel={() => setConfirmDelete(null)}
                    onConfirm={() => deleteAgreement()}
                    translateConfirmTexts={false}
                />
            }

        </>
    )
}

AgreementsCreatedPanel.propTypes = {
    demandId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    editable: PropTypes.bool.isRequired,
}

export default connect((state) => ({
    agreementsList: state.resources[AgreementsService.AGREEMENTS_RESOURCE_ID]
}), {})(AgreementsCreatedPanel);

